<!-- <mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                     <label> </label>
                    <input id="search" name="search" type="text" [(ngModel)]="documentCode" (change)="retriveIPrepLookUp()"  placeholder="Document Code" style="width: 20%;">
                    <label>       </label>
                    <input id="search" name="search" type="text" [(ngModel)]="paatintCode" (change)="retriveIPrepLookUp()" placeholder="Patiemt Code" style="width: 20%;" >
                    <label>       </label>
                    <input id="search" name="search" type="text" [(ngModel)]="patientFName" (change)="retriveIPrepLookUp()" placeholder="Patiemt Name"  style="width: 50%;">

                </form>
            </div>
        </div>
    </div>
  </section>

  <table>
    <thead>
        <tr >
            <th style="width: 20%;">Doc. Code</th>
            <th style="width: 20%;">Doc. Date</th>
            <th style="width: 25%;">Patient Code</th>
            <th style="width: 120%;">Patient Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pro of preparationList; let i = index">
            <td data-column="Protocol ID">  {{pro.docNumber}}   </td>
            <td data-column="Document Date">{{pro.docDate}}     < /td>
            <td data-column="Protocol Name">{{pro.paIntCode}}   </td>
            <td data-column="Protocol Name">{{pro.patientFName}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectItem(pro)">Select</button>
            </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>

 -->




 <mat-dialog-content class="customer-dialog">
  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Document Code</mat-label>
      <input matInput [(ngModel)]="documentCode" (keyup)="retriveIPrepLookUp()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Patient Code</mat-label>
      <input matInput [(ngModel)]="paatintCode" (keyup)="retriveIPrepLookUp()">
    </mat-form-field>
        <mat-form-field  >
      <mat-label>Patient Name</mat-label>
      <input matInput [(ngModel)]="patientFName" (keyup)="retriveIPrepLookUp()">
    </mat-form-field>

  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
            <th style="width: 20%;">Doc. Code</th>
            <th style="width: 20%;">Doc. Date</th>
            <th style="width: 25%;">Patient Code</th>
            <th style="width: 120%;">Patient Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pro of preparationList; let i = index">
        <td>{{pro.docNumber}}   </td>
        <td>{{pro.docDate}}     </td>
        <td>{{pro.paIntCode}}   </td>
        <td>{{pro.patientFName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectItem(pro)">Select</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>


